export const apiConfig = {
  account: {
    baseUrl:
      process.env.VUE_APP_ACCOUNT_API_URL ||
      "https://account.roomsvileapi.com.ng/api/",
  },
  rooms: {
    baseUrl:
      process.env.VUE_APP_ROOMS_API_URL ||
      "https://rooms.roomsvileapi.com.ng/api/",
  },
  bookings: {
    baseUrl:
      process.env.VUE_APP_BOOKINGS_API_URL ||
      "https://bookings.roomsvileapi.com.ng/api/",
  },
  utility: {
    baseUrl:
      process.env.VUE_APP_UTILITY_API_URL ||
      "https://utility.roomsvileapi.com.ng/api/",
  },
  location: {
    countryId: "18e3f0dd-54ae-4505-865f-73cc67d827e8",
  },
};

export default apiConfig;
